<template>
  <div class="clerk-list">
    <div class="clerk-package" v-for="(item, index) in clerkList" :key="index">
      <div class="name">{{ item.nickname }}</div>
      <div class="phone">{{ item.phone }}</div>
      <div class="operation">
        <div class="tips">{{ item.role | roleFilter }}</div>
        <div class="btn" v-if="item.role != 2">
          <span
            class="iconfont iconshanchu1"
            @click="handleDelete(item.id)"
          ></span>
          <span class="iconfont iconbianji" @click="handleEdit(item)"></span>
        </div>
      </div>
    </div>
    <div class="add">
      <van-button type="primary" @click="handleAdd">
        新增店员
      </van-button>
    </div>
  </div>
</template>
<script>
import "@/icons/iconfont.css";
import { accounts, Newdisable } from "@/api/clerk";
import { Dialog } from "vant";

export default {
  data() {
    return {
      clerkList: []
    };
  },
  filters: {
    roleFilter(val) {
      switch (val) {
        case 2:
          return "店主";
        case 16:
          return "维修工";
        default:
          return "用户";
      }
    }
  },
  mounted() {
    this.handleclerkList();
  },
  methods: {
    // 店员列表
    handleclerkList() {
      accounts().then(res => {
        console.log("店员列表 :>> ", res);
        this.clerkList = res;
      });
    },
    // 删除店员
    handleDelete(id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定禁用该店员吗?"
      }).then(() => {
        Newdisable(id).then(res => {
          if (res.code === 0) {
            this.$toast("店员已禁用");
            this.handleclerkList();
          }
        });
      });
    },
    // 添加店员
    handleAdd() {
      this.$router.replace("/clerk/salesclerkAdd");
    },
    // 编辑店员
    handleEdit(data) {
      this.$toast("无法修改");
      console.log(data)
      // localStorage.setItem("clerkData", JSON.stringify(data));
      // this.$router.replace("/clerk/salesclerkAdd");
    }
  }
};
</script>
<style lang="scss" scoped>
.clerk-list {
  padding: 20px 10px;

  .clerk-package {
    padding: 20px;
    margin-bottom: 20px;
    background-color: #f4f4f4;

    .name {
      text-align: left;
      margin-bottom: 10px;
    }

    .phone {
      text-align: left;
      margin-bottom: 10px;
    }

    .operation {
      display: flex;
      align-items: center;

      .tips {
        flex: 1;
        text-align: left;
      }

      .btn {
        flex: 1;
        text-align: right;

        .iconfont {
          font-size: 20px;
        }

        .iconshanchu1 {
          margin-right: 30px;
          color: red;
        }

        .iconbianji {
          color: blue;
        }
      }
    }
  }

  .add {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
<style lang="scss"></style>
